import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { LoginService } from '../services/login.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private auth: LoginService, private router: Router) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    // console.log(this.auth.isLoggednIn());
    if (this.auth.isLoggednIn()) {
      return true;
    } else {
      // this.myRoute.navigate(['/authentication/login']);
      // this.router.navigate(['/login-2']);
      this.router.navigate(["/auth/login-2"]); 
      return false;
    }

    // return false;
  }


    // canActivate(): boolean {
  //   if (!this.auth.isAuthenticated()) {
  //     this.router.navigate(['login']);
  //     return false;
  //   }
  //   return true;
  // }
  

  // canActivate(): boolean {
  //   if (!this.auth.isLoggednIn()) {
  //     this.router.navigate(['/login-2']);
  //     return false;
  //   }
  //   return true;
  // }



}
